/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * TagIcon
 */
export default class TagIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M18.789 2.364a3 3 0 012.852 2.954l-.003.19-.311 6.32a3 3 0 01-.724 1.811l-.151.164-7.96 7.96a3 3 0 01-4.115.12l-.128-.12-6.01-6.01a3 3 0 01-.121-4.115l.12-.128 7.96-7.96a3 3 0 011.753-.856l.222-.02 6.32-.31a3 3 0 01.296 0zM18.69 4.36h-.098l-6.321.311a1 1 0 00-.566.21l-.092.082-7.96 7.96a1 1 0 00-.078 1.327l.078.087 6.01 6.01a1 1 0 001.327.078l.088-.078 7.96-7.96a1 1 0 00.278-.535l.013-.123.311-6.32a1 1 0 00-.95-1.049zm-.779 1.73a2.5 2.5 0 11-3.535 3.535A2.5 2.5 0 0117.91 6.09zM15.79 7.503a.5.5 0 10.707.707.5.5 0 00-.707-.707z" fillRule="evenodd"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

